module.exports = __webpack_public_path__ + "static/media/revert.dd2b5402.svg";